<template>
  <div class="card">
    <!-- <button @click="test">hola</button> -->
    <div class="card-header">
      <h4 class="title">Editar Perfil</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
          <div class="col-md-5">
            <fg-input
              type="text"
              label="Empresa"
              :disabled="true"
              placeholder="Paper dashboard"
              v-model="user.company"
            >
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="text"
              label="Usuario"
              placeholder="Username"
              v-model="user.username"
            >
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input
              type="email"
              label="Correo"
              placeholder="Email"
              v-model="user.email"
            >
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Nombre"
              placeholder="Nombre usuario"
              v-model="user.name"
            >
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="text"
              label="RUT"
              placeholder="RUT"
              v-model="user.NID"
            >
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="string"
              label="País"
              placeholder="País"
              v-model="user.country"
            >
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <fg-input
              type="string"
              label="Perfil"
              placeholder="Perfil"
              v-model="user.profile"
            >
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              type="string"
              label="Estado"
              placeholder="Estado"
              v-model="user.status"
            >
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              type="string"
              label="Ultimo Inicio de Sesión"
              placeholder="DD-MM-AAAA HH:mm:ss"
              v-model="user.lastLogin"
              disabled
            >
            </fg-input>
          </div>
        </div>
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="updateProfile"
            disabled
          >
            Actualizar
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {
        company: "",
        username: "",
        email: "",
        name: "",
        status: "",
        profile: "",
        NID: "",
        phone: "",
        lastLogin: "",
        country: "",
      },
    };
  },
  methods: {
    test() {
      console.log(this.$store.getters.getUserData);
    },
    updateProfile() {
      alert("Your data: " + JSON.stringify(this.user));
    },
  },
  beforeMount() {
    this.$swal.close();
    const userData = this.$store.getters.getUserData;
    this.user.company = userData.empresa.nombreFantasia;
    this.user.username = userData.usuarioSesion;
    this.user.email = userData.email;
    this.user.name = userData.nombreUsuario;
    this.user.NID = userData.informacionAdicional.rut || "76.903.216-9";
    this.user.phone = userData.informacionAdicional.celular;
    this.user.lastLogin = this.$moment(userData.fechaUltimoAcceso).format(
      "DD-MM-YYYY HH:MM:ss"
    );
    this.user.country = userData.empresa.cliente.nacionalidad;
    this.user.profile = userData.perfilCuenta.glosa
    this.user.status = userData.estadoCuenta.glosa
  },
};
</script>
<style></style>
